export default "__VITE_ASSET__CQRF1dJ3__"